<content>
  <header>
    <div class="exercise-time">
      <div>TIME ELAPSED</div>
      <div class="subtext">{{ timeElapsed }}</div>
    </div>
    <div fxFlex class="exercise-count">
      <div>STEP</div>
      <div class="subtext">{{ (currentTierIndex$ | async) + 1  }} of {{ this.currentWorkoutSession.workout.tiers.length }}</div>
    </div>
    <div class="exercise-end">
      <button mat-raised-button color="warn" (click)="endWorkout()">FINISH</button>
    </div>
  </header>
  <main>
    <app-subexercise (tierChanged)="changeTier()"></app-subexercise>
  </main>
</content>
